import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {TreeviewI18n} from "../common/components/tree/models/treeview-i18n";
import {TreeviewSelection} from "../common/components/tree/models/treeview-item";

@Injectable()
export class MyTreeviewLanguage extends TreeviewI18n {

  getAllCheckboxText(): string {
    return this.translate.instant('All');
  }

  getFilterPlaceholder(): string {
    return this.translate.instant('Filter');
  }

  getFilterNoItemsFoundText(): string {
    return this.translate.instant('NoItems');
  }

  getTooltipCollapseExpandText(isCollapse: boolean): string {
    return isCollapse ? this.translate.instant('Expand') : this.translate.instant('Collapse');
  }
  translate: TranslateService;

  constructor (translate: TranslateService) {
      super();
      this.translate = translate;
  }


  getText(selection: TreeviewSelection): string {
    if (selection){
      if (selection.uncheckedItems.length===0){
        return this.translate.instant('All');
      }


      switch (selection.checkedItems.length) {
        case 0:
          return this.translate.instant('PleaseSelect');
        case 1:
          return selection.checkedItems[0].text;
        default:
          return this.translate.instant('NbrSelectedOptions', {nbOptions: selection.checkedItems.length});
        // `${checkededItems.length} options sélectionnées`
      }
    }
    return this.translate.instant('PleaseSelect');
  }

}


@Injectable()
export class MyTreeViewForUnitI18n extends TreeviewI18n {

  getAllCheckboxText(): string {
    return this.translate.instant('All');
  }

  getFilterPlaceholder(): string {
    return this.translate.instant('Filter');
  }

  getFilterNoItemsFoundText(): string {
    return this.translate.instant('NoUnits');
  }

  getTooltipCollapseExpandText(isCollapse: boolean): string {
    return isCollapse ? this.translate.instant('Expand') : this.translate.instant('Collapse');
  }

  translate: TranslateService;

  constructor (translate: TranslateService) {
    super();
    this.translate = translate;
  }

  getText(selection: TreeviewSelection): string {
    if (selection){
      if (selection.uncheckedItems.length===0){
        return this.translate.instant('All');
      }


      switch (selection.checkedItems.length) {
        case 0:
          return this.translate.instant('PleaseSelectUnit');
        case 1:
          return selection.checkedItems[0].text;
        default:
          return this.translate.instant('NbrSelectedUnit', {nbOptions: selection.checkedItems.length});
        // `${checkededItems.length} options sélectionnées`
      }
    }
    return this.translate.instant('PleaseSelectUnit');
  }

 /*
  getTextOLD(checkededItems: TreeviewItem[], isAll: boolean): string {
    // console.log('getText ' + isAll);
    if (isAll) {
      return this.translate.instant('All');
    }

    switch (checkededItems.length) {
      case 0:
        return this.translate.instant('PleaseSelectUnit');
      case 1:
        return checkededItems[0].text;
      default:
        return this.translate.instant('NbrSelectedUnit', {nbOptions: checkededItems.length});
      // `${checkededItems.length} options sélectionnées`
    }
  }

  allCheckboxText(): string {
    // console.log('allCheckBoxText');
    return this.translate.instant('All');
  }

  filterPlaceholder(): string {
    // console.log('filterPlaceHolder');
    return this.translate.instant('Filter');
  }

  filterNoItemsFoundText(): string {
    // console.log('filterNoItemsFoundText');
    return this.translate.instant('NoUnits');
  }

  tooltipCollapseExpand(isCollapse: boolean): string {
    // console.log('tooltipCollapseExpand');
    return isCollapse ? this.translate.instant('Expand') : this.translate.instant('Collapse');
  }
  */
}
